export default __webpack_public_path__ + "static/media/telegram.956a9911.svg";